import React from 'react';

interface TextAreaFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  isEditing: boolean;
  rows?: number;
}

export const TextAreaField: React.FC<TextAreaFieldProps> = ({
  label,
  value,
  onChange,
  isEditing,
  rows = 2,
}) => {
  return (
    <div className='pt-2'>
      <span className='text-gray-600'>{label}:</span>
      {isEditing ? (
        <textarea
          value={value || ''}
          onChange={e => onChange(e.target.value || '')}
          className='mt-1 w-full text-xs px-2 py-1 border border-gray-300 rounded'
          rows={rows}
        />
      ) : (
        <p className='mt-1 text-gray-800 text-xs italic'>{value || 'N/A'}</p>
      )}
    </div>
  );
};
